module.exports = __webpack_public_path__ + "img/logo-ministerio-seguridad-nacional.2faa61c4.jpeg";